import { FC } from 'react'

interface IconArrowCircleRightProps {
  className?: string
}

export const IconArrowCircleRight: FC<IconArrowCircleRightProps> = ({ className }) => {
  return (
    <svg className={className} viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="15" cy="15" r="15" fill="black" fillOpacity="0.05" />
      <path
        d="M13.1289 10.9766L17.4219 15.2237L13.1461 19.4708"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  )
}
